import * as React from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import { inject } from '../../../utils';
import { withTheme } from 'styled-components';
import { styled } from '../../../utils/styled';
import { propStyles } from '../../../utils/propStyles';
import Icon from '../../Icon';
import _FilterItemDropdown from './Filter/FilterItemDropdown';
import Badge from '../../Badge';
import ClearFilters from '../../ClearFilters';
import withFilter from '../withFilter';
import HTag from '../../HTag';
import { isNullOrEmpty } from '@kurtosys/ksys-app-template/dist/utils/typeChecks';
import { FiltersProps } from '../../../models/components/Filter';

const FilterItemDropdown = withFilter(_FilterItemDropdown);

const FiltersWrapper = styled<any, any>(
    'aside',
    'filtersWrapper',
    'filtersTop'
)`
    ${propStyles};
`;

FiltersWrapper.defaultProps = {
    display: 'flex',
    flexDirection: 'column',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'none none solid none',
    paddingY: 'md',
};

const FiltersWrapperInner = styled<any, any>(
    'div',
    'filtersWrapperInner',
    'filtersTop'
)`
    ${propStyles};
`;

FiltersWrapperInner.defaultProps = {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: ['stretch', 'flex-end'],
    flexDirection: ['column', 'row'],
    paddingY: 'md',
};

const FiltersHeader = styled<any, any>('div', 'filtersHeader', 'filtersTop')`
    ${propStyles};
    flex-shrink: 0;
`;

FiltersHeader.defaultProps = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: 'body',
    paddingX: 'lg',
};

const FiltersHeaderToggle = styled<any, any>(
    'button',
    'filtersHeaderToggle',
    'filtersTop'
)`
    ${propStyles};
    outline: none;
    cursor: pointer;
`;

FiltersHeaderToggle.defaultProps = {
    display: 'flex',
    alignItems: 'center',
    flex: '1 0 auto',
    fontFamily: 'heading',
    fontWeight: 'medium',
    fontSize: 'inherit',
    color: 'body',
    bgColor: 'transparent',
    borderStyle: 'none',
};

@inject('dataStore', 'filterStore', 'accessibilityStore')
@observer
class FiltersTop extends Component<FiltersProps> {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { filterStore } = this.props;
        filterStore.filtersOpenDefault();
    }

    componentDidUpdate(prevProps: Readonly<FiltersProps>): void {
        if (prevProps !== this.props) {
            const { filterStore } = this.props;
            filterStore.filtersOpenDefault();
        }
    }

    render() {
        const {
            theme,
            filterStore,
            accessibilityStore,
            dataStore,
        } = this.props;
        const { filtersOpen, filtersTopExpandable } = filterStore;

        const { hasResponsiveLayoutHeader } = dataStore.config;

        if (isNullOrEmpty(filterStore.filters)) {
            return null;
        }

        return (
            <FiltersWrapper
                className={filtersOpen ? 'open' : ''}
                {...theme.FiltersTopWrapper}
                role="complementary"
                aria-label={accessibilityStore.filtersLandmark}
            >
                {!hasResponsiveLayoutHeader && (
                    <FiltersHeader {...theme.FiltersTopHeader}>
                        <FiltersHeaderToggle
                            {...filterStore.filtersHeaderToggleProps}
                            {...theme.FiltersTopHeaderToggle}
                        >
                            {filtersTopExpandable && (
                                <Icon
                                    fileName={
                                        filtersOpen
                                            ? 'FiltersTopHeaderToggleIconExpanded'
                                            : 'FiltersTopHeaderToggleIcon'
                                    }
                                    aria-hidden="true"
                                    {...theme.FiltersTopHeaderToggleIcon}
                                />
                            )}
                            <HTag
                                defaultStyleProps={{
                                    fontWeight: 'inherit',
                                }}
                                level={3}
                                text={'Filters'}
                            />
                            {filterStore.filtersActive && (
                                <Badge
                                    marginX="sm"
                                    bgColor="primary"
                                    {...theme.FiltersToggleBadge}
                                    {...theme.FiltersTopToggleBadge}
                                >
                                    {filterStore.filtersCount}
                                </Badge>
                            )}
                        </FiltersHeaderToggle>
                        {filterStore.filtersActive && (
                            <ClearFilters
                                margin="0 0 0 auto"
                                theme={{
                                    ...theme,
                                    FiltersClearButton:
                                        theme.FiltersTopClearButton,
                                    ClearFiltersIcon: theme.ClearFiltersTopIcon,
                                }}
                            />
                        )}
                    </FiltersHeader>
                )}
                {filtersOpen && (
                    <FiltersWrapperInner
                        id={'filters-top-expanded-content'}
                        {...theme.FiltersTopWrapperInner}
                        display="flex"
                    >
                        {filterStore.filters.map(filter => (
                            <FilterItemDropdown
                                key={filter.property}
                                filter={filter}
                            />
                        ))}
                    </FiltersWrapperInner>
                )}
            </FiltersWrapper>
        );
    }
}

export default withTheme(FiltersTop);



// WEBPACK FOOTER //
// ./src/Components/Filters/Components/FiltersTop.tsx